import { render, staticRenderFns } from "./ComTable.vue?vue&type=template&id=ff605de8&scoped=true&slot-scope=scope&"
import script from "./ComTable.vue?vue&type=script&lang=js&"
export * from "./ComTable.vue?vue&type=script&lang=js&"
import style0 from "./ComTable.vue?vue&type=style&index=0&id=ff605de8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff605de8",
  null
  
)

export default component.exports